import React, { useState, useEffect } from 'react';
import PerfectScrollbar from 'react-perfect-scrollbar';
import {
  Box,
  Card,
  makeStyles,
  Container,
  Divider,
  CardContent,
  Grid,
  TextField,
  MenuItem,
  InputLabel,
  CardHeader,
  Button
} from '@material-ui/core';
import Page from 'src/components/Page';
import PageHeader from 'src/views/Common/PageHeader';
import services from '../Services';
import { useNavigate } from 'react-router-dom';
import { trackPromise } from 'react-promise-tracker';
import authService from '../../../utils/permissionAuth';
import tokenService from '../../../utils/tokenDecoder';
import MaterialTable from "material-table";
import { Formik } from 'formik';
import * as Yup from "yup";
import { LoadingComponent } from 'src/utils/newLoader';

const useStyles = makeStyles((theme) => ({
  root: {
    backgroundColor: theme.palette.background.dark,
    minHeight: '100%',
    paddingBottom: theme.spacing(3),
    paddingTop: theme.spacing(3)
  },
  avatar: {
    marginRight: theme.spacing(2)
  },
  colorRecord: {
    backgroundColor: 'green'
  }
}));

const screenCode = "ROUTEMANAGERREGISTRATION";

export default function RouteManagerListing() {
  const classes = useStyles();
  const [btnDisable, setBtnDisable] = useState(false);
  const [isTableHide, setIsTableHide] = useState(false);
  const [routeManagerData, setRouteManagerData] = useState()
  const [routeManager, setRouteManager] = useState({
    groupID: '0',
    factoryID: '0',
    routeID: '0'
  });
  const [groups, setGroups] = useState();
  const [factories, setFactories] = useState();
  const [routes, setRoutes] = useState();
  const [isUpdate, setIsUpdate] = useState(false);
  const [permissionList, setPermissions] = useState({
    isGroupFilterEnabled: false,
    isFactoryFilterEnabled: false,
  });
  const navigate = useNavigate();
  let encryptedID = "";


  useEffect(() => {
    trackPromise(
      getPermission()
    );
  }, []);

  useEffect(() => {
    trackPromise(
      getFactoriesForDropDown(),
    )
    setIsTableHide(false);
  }, [routeManager.groupID]);

  useEffect(() => {
    if (routeManager.factoryID && routeManager.factoryID !== '0' &&
      routeManager.groupID && routeManager.groupID !== '0') {
      trackPromise(
        getRoutesForDropDown()
      );
    }
  }, [routeManager.factoryID, routeManager.groupID]);


  async function getPermission() {
    var permissions = await authService.getPermissionsByScreen(screenCode);
    var isAuthorized = permissions.find(p => p.permissionCode == 'ADDEDITROUTEMANAGERREGISTRATION');

    if (isAuthorized === undefined) {
      navigate('/404');
    }
    var isGroupFilterEnabled = permissions.find(p => p.permissionCode == 'GROUPDROPDOWN');
    var isFactoryFilterEnabled = permissions.find(p => p.permissionCode == 'FACTORYDROPDOWN');

    setPermissions({
      ...permissionList,
      isGroupFilterEnabled: isGroupFilterEnabled !== undefined,
      isFactoryFilterEnabled: isFactoryFilterEnabled !== undefined,
    });

    const tokenGroupID = tokenService.getGroupIDFromToken();
    const tokenFactoryID = tokenService.getFactoryIDFromToken();

    setRouteManager(prev => ({
      ...prev,
      groupID: tokenGroupID ? parseInt(tokenGroupID) : '0',
      factoryID: tokenFactoryID ? parseInt(tokenFactoryID) : '0'
    }));

    trackPromise(getGroupsForDropdown());
  }

  async function getFactoriesForDropDown() {
    const factoryList = await services.getFactoryByGroupID(routeManager.groupID);
    setFactories(factoryList);
  }

  async function getGroupsForDropdown() {
    const groups = await services.getAllGroups();
    setGroups(groups);
  }

  async function getRoutesForDropDown() {
    const routes = await services.getRoutesForDropDown(routeManager.factoryID, routeManager.groupID);
    setRoutes(routes);
  }
  const handleClick = () => {
    encryptedID = btoa('0');
    navigate('/app/routeManagerRegistration/addEdit/' + encryptedID);
  }
  const EditRouteManagerDetails = (routeManagerID) => {
    encryptedID = btoa(routeManagerID.toString());
    navigate('/app/routeManagerRegistration/addedit/' + encryptedID);
  }
  function cardTitle(titleName) {
    return (
      <Grid container spacing={1}>
        <Grid item md={10} xs={12}>
          {titleName}
        </Grid>
        <Grid item md={2} xs={12}>
          <PageHeader
            onClick={handleClick}
            isEdit={true}
            toolTiptitle={"Add Route Manager"}
          />
        </Grid>
      </Grid>
    )
  }

  async function searchDetails(values) {

    let general = {
      routeID: values.routeID,
      groupID: values.groupID,
      factoryID: values.factoryID,
    }
    btnchecking();
    var response = await services.getAllRouteManagers(general);
    setRouteManagerData(response.data);
    setIsTableHide(true);
  }
  function btnchecking() {
    setBtnDisable(false);
  }

  function generateDropDownMenu(data) {
    let items = []
    if (data != null) {
      for (const [key, value] of Object.entries(data)) {
        items.push(<MenuItem key={key} value={key}>{value}</MenuItem>);
      }
    }
    return items
  }

  function handleChangeForm(e) {
    const { name, value } = e.target;
    setRouteManager(prev => ({
      ...prev,
      [name]: value
    }));
  }

  return (
    <Page className={classes.root} title="Route Manager Details Add Edit">
      <Container maxWidth={false}>
        <LoadingComponent />
        <Formik
          initialValues={{
            groupID: routeManager.groupID,
            factoryID: routeManager.factoryID,
            routeID: routeManager.routeID,
          }}
          validationSchema={
            Yup.object().shape({
              groupID: Yup.number().required('Group is required').min("1", 'Group is required'),
              factoryID: Yup.number().required('Factory is required').min("1", 'Factory is required'),
            })
          }
          onSubmit={(values) => searchDetails(values)}
          enableReinitialize
        >
          {({
            errors,
            handleBlur,
            handleSubmit,
            touched
          }) => (
            <form onSubmit={handleSubmit}>
              <Box mt={3}>
                <Card className={classes.cardContent}>
                  <CardHeader
                    title={cardTitle("Route Manager")}
                  />
                  <PerfectScrollbar>
                    <Divider />
                    <CardContent >
                      <Grid container spacing={3}>
                        <Grid item md={4} xs={12}>
                          <InputLabel shrink id="groupID">
                            Group *
                          </InputLabel>
                          <TextField select
                            error={Boolean(errors.groupID)}
                            fullWidth
                            helperText={errors.groupID}
                            size='small'
                            name="groupID"
                            onBlur={handleBlur}
                            onChange={(e) => handleChangeForm(e)}
                            value={routeManager.groupID}
                            variant="outlined"
                            id="groupID"
                            InputProps={{
                              readOnly: isUpdate || !permissionList.isGroupFilterEnabled ? true : false,
                            }}
                          >
                            <MenuItem value='0'>--Select Group--</MenuItem>
                            {generateDropDownMenu(groups)}
                          </TextField>
                        </Grid>
                        <Grid item md={4} xs={12}>
                          <InputLabel shrink id="factoryID">
                            Factory *
                          </InputLabel>
                          <TextField select
                            error={Boolean(errors.factoryID)}
                            fullWidth
                            helperText={errors.factoryID}
                            size='small'
                            name="factoryID"
                            onBlur={handleBlur}
                            onChange={(e) => handleChangeForm(e)}
                            value={routeManager.factoryID}
                            variant="outlined"
                            InputProps={{
                              readOnly: isUpdate || !permissionList.isFactoryFilterEnabled ? true : false,
                            }}
                          >
                            <MenuItem value='0'>--Select Factory--</MenuItem>
                            {generateDropDownMenu(factories)}
                          </TextField>
                        </Grid>
                        <Grid item md={4} xs={12}>
                          <InputLabel shrink id="routeID">
                            Route
                          </InputLabel>
                          <TextField select
                            error={Boolean(touched.routeID && errors.routeID)}
                            fullWidth
                            helperText={touched.routeID && errors.routeID}
                            size='small'
                            name="routeID"
                            onBlur={handleBlur}
                            onChange={(e) => handleChangeForm(e)}
                            value={routeManager.routeID}
                            variant="outlined"
                            // InputProps={{
                            //   readOnly: isUpdate || !permissionList.isFactoryFilterEnabled ? true : false,
                            // }}
                          >
                            <MenuItem value='0'>--Select Route--</MenuItem>
                            {generateDropDownMenu(routes)}
                          </TextField>
                        </Grid>
                      </Grid>
                    </CardContent>
                    <Box display="flex" justifyContent="flex-end" p={2}>
                      <Button
                        color="primary"
                        disabled={btnDisable}
                        type="submit"
                        variant="contained"
                      >
                        Search
                      </Button>
                    </Box>
                    {isTableHide ?
                      <Box minWidth={1000}>
                        <MaterialTable
                          title="Multiple Actions Preview"
                          columns={[
                            {
                              title: 'Route Manager Name', field: 'fullName',
                              render: rowData => `${rowData.firstName == null ? '' : rowData.firstName} ${rowData.secondName == null ? '' : rowData.secondName} ${rowData.lastName == null ? '' : rowData.lastName}`,
                              customFilterAndSearch: (term, rowData) =>
                                (`${rowData.firstName || ''} ${rowData.secondName || ''} ${rowData.lastName || ''}`)
                                  .toLowerCase()
                                  .includes(term.toLowerCase())
                            },
                            { title: 'Route', field: 'routeID', render: rowData => routes[rowData.routeID] },
                            { title: 'Route Manager Code', field: 'routeManagerCode' },
                            {
                              title: 'Status', field: 'isActive',
                              render: rowData => rowData.isActive ? "Active" : "Inactive"
                            }
                          ]}

                          data={routeManagerData}
                          options={{
                            exportButton: false,
                            showTitle: false,
                            headerStyle: { textAlign: "left", height: '1%' },
                            cellStyle: { textAlign: "left" },
                            columnResizable: false,
                            actionsColumnIndex: -1,

                          }}
                          actions={[
                            {
                              icon: 'edit',
                              tooltip: 'Edit Route Manager',
                              onClick: (event, rowData) => {
                                EditRouteManagerDetails(rowData.routeManagerID);
                              }
                            }
                          ]}
                        />
                      </Box>
                      : null}

                    {isTableHide ?

                      <Box display="flex" justifyContent="flex-end" p={2}>
                      </Box>

                      : null}
                  </PerfectScrollbar>
                </Card>
              </Box>
            </form>
          )}
        </Formik>
      </Container>
    </Page>
  );
};

